import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="repot"
export default class extends Controller {
  static targets = ["x", "y", "z", "estimatedSelect", "repotSelect"]
  static values = {
    repotPrices: Array
  }

  recalc() {
    const x = parseFloat(this.xTarget.value) || 0
    const y = parseFloat(this.yTarget.value) || 0
    const z = parseFloat(this.zTarget.value) || 0

    const raw = (x * y * z) / 1000
    const computedPrice = Math.ceil(raw)

    const matched = this.repotPricesValue.find(rp => rp.name === computedPrice.toString())

    if (matched) {
      this.estimatedSelectTarget.value = matched.id.toString()
      this.repotSelectTarget.value = matched.id.toString()
    } else {
      this.estimatedSelectTarget.value = ""
      this.repotSelectTarget.value = ""
    }
  }
}
